import { render, staticRenderFns } from "./AbTestVariantSourceLabel.vue?vue&type=template&id=6728835d&scoped=true&"
import script from "./AbTestVariantSourceLabel.vue?vue&type=script&lang=js&"
export * from "./AbTestVariantSourceLabel.vue?vue&type=script&lang=js&"
import style0 from "./AbTestVariantSourceLabel.vue?vue&type=style&index=0&id=6728835d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728835d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
